import React from "react";
import { Chip } from "./ui";

// options defaults to [] because this component has no error boundary above it:
// a caller that passes undefined took down the WHOLE React tree, leaving an
// empty #app rather than a missing chip list. Observed while driving the real
// page in a browser.
//
// Applied-filter chips: Chip's × stops propagation itself and is labelled
// "Remove <name>".
const MultiSelectDisplay = ({ options = [], onRemove, className = "" }) => {
  return (
    <div className={`multiselect d-flex flex-wrap gap-2 ${className}`}>
      {options.map((o) => (
        <Chip
          key={o.id}
          selected
          onRemove={onRemove ? () => onRemove(o) : undefined}
        >
          {o.name}
        </Chip>
      ))}
    </div>
  );
};

export default MultiSelectDisplay;
